import './App.css';
import 'react-toastify/dist/ReactToastify.css';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { TOKEN_KEY } from '../common/constants';
import { RootState } from '../common/types';
import { whoami, whoamiSuccess } from '../features/login/login.slice';
import RootRoutes from './rootRoutes';

const promiseStripe = loadStripe(process.env.REACT_APP_STRIPE_KEY || '');

function App(): JSX.Element {
  const accessToken = localStorage.getItem(TOKEN_KEY);
  const dispatch = useDispatch();

  const { user } = useSelector((state: RootState) => state.login);

  useEffect(() => {
    if (!accessToken) {
      dispatch(whoamiSuccess(null));
    } else if (accessToken && !user) {
      dispatch(whoami());
    }
  }, [accessToken, user, dispatch]);

  return (
    <>
      <Helmet>
        <title>ShvrkPools</title>
      </Helmet>
      <Elements stripe={promiseStripe}>
        <RootRoutes />
        <ToastContainer />
      </Elements>
    </>
  );
}

export default App;
